import React from "react";
import PropTypes from "prop-types";

import { ReactComponent as Loader } from "../../../assets/icons/loader.svg";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  StyledButton
} from "./styled";

export const ConfirmDialog = ({
  title = "Are you sure?",
  message,
  handleClose,
  isOpen,
  handleConfirm,
  cancelLabel = "Cancel",
  confirmLabel = "Yes, I'm sure",
  divider = true,
  isDisplayBtnLoader = false,
  disableBackdropClick,
  disableEscapeKeyDown,
  className,
  classNameDialogActions
}) => {
  /* istanbul ignore next */
  const onClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }

    if (disableEscapeKeyDown && reason === "escapeKeyDown") {
      return false;
    }

    if (typeof handleClose === "function") {
      handleClose();
    }
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="draggable-dialog-title"
      classes={{
        container: className,
        paper: title ? "paper" : "noTitlePaper"
      }}
      data-testid="confirm-dialog"
    >
      {title && (
        <StyledDialogTitle className="title" id="draggable-dialog-title">
          {title}
        </StyledDialogTitle>
      )}
      <StyledDialogContent>{message}</StyledDialogContent>
      {divider && <div className="divider" />}
      {(handleClose || handleConfirm) && (
        <StyledDialogActions className={classNameDialogActions}>
          {handleClose && (
            <StyledButton
              onClick={handleClose}
              color="primary"
              variant="outlined"
              disabled={isDisplayBtnLoader}
              data-testid="cancelButton"
            >
              {cancelLabel}
            </StyledButton>
          )}
          {handleConfirm && (
            <StyledButton
              onClick={handleConfirm}
              color="primary"
              variant="contained"
              className="marginTop12"
              data-testid="confirmButton"
            >
              {isDisplayBtnLoader ? (
                <Loader data-testid="confirm-dialog-loader" className="loader" alt="loading" />
              ) : (
                confirmLabel
              )}
            </StyledButton>
          )}
        </StyledDialogActions>
      )}
    </StyledDialog>
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.node,
  handleClose: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  divider: PropTypes.bool,
  isDisplayBtnLoader: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  className: PropTypes.string,
  classNameDialogActions: PropTypes.string
};
